import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AttributeChangeSchedule } from 'src/app/model/schedule/attribute-change-schedule';
import { MembershipTypeScheduleUtils } from 'src/app/util/membership-type-schedule-util';

@Component({
  selector: 'gymfinder-attribute-change-schedule-table',
  templateUrl: './attribute-change-schedule-table.component.html',
  styleUrls: ['./attribute-change-schedule-table.component.scss'],
  standalone: false,
})
export class AttributeChangeScheduleTableComponent implements OnInit {
  displayedColumns: string[];

  @Input()
  schedules?: AttributeChangeSchedule[];

  @Input()
  allowEdit = false;

  @Output()
  scheduleDelete = new EventEmitter<AttributeChangeSchedule>();

  ngOnInit(): void {
    if (this.allowEdit) {
      this.displayedColumns = [
        'name',
        'field',
        'value',
        'scheduledAt',
        'action',
      ];
    } else {
      this.displayedColumns = [
        'name',
        'field',
        'value',
        'scheduledAt',
        'executedAt',
      ];
    }
  }

  public hasSchedules(): boolean {
    return (this.schedules && this.schedules.length > 0) || false;
  }

  public displayName(schedule: AttributeChangeSchedule): string {
    return MembershipTypeScheduleUtils.displayName(schedule);
  }

  public displayValue(schedule: AttributeChangeSchedule): string {
    return MembershipTypeScheduleUtils.displayValue(schedule);
  }

  public handleDeleteSchedule(schedule: AttributeChangeSchedule) {
    this.scheduleDelete.emit(schedule);
  }
}
